<template>
  <div class="main">
    <MoleculesHeaderLogo v-if="!isAboutPage()" />
    <div class="main__contents">
      <router-view />
    </div>
  </div>
</template>
<script>
import MoleculesHeaderLogo from "@/components/molecules/headerLogo/HeaderLogo.vue";

export default {
  name: "Main",
  components: {
    MoleculesHeaderLogo,
  },
  methods: {
    isAboutPage() {
      return this.$router.currentRoute.name === "about";
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/common.scss";
</style>
